import { lazy } from 'react';

export const FeedAdditiveAddRequestPage = lazy(
  () => import('./FeedAdditiveAddRequest/FeedAdditiveAddRequest')
);

export const FeedAdditiveViewRequestPage = lazy(
  () => import('./FeedAdditiveViewRequest/FeedAdditiveViewRequest')
);

export const FeedAdditiveEditRequestPage = lazy(
  () => import('./FeedAdditiveEditRequest/FeedAdditiveEditRequest')
);

export const FeedAdditiveViewRecordPage = lazy(
  () => import('./FeedAdditiveViewRecord/FeedAdditiveViewRecord')
);

export const FeedAdditiveEditRecordPage = lazy(
  () => import('./FeedAdditiveEditRecord/FeedAdditiveEditRecord')
);
